import { supabase } from './supabase';

export const storageService = {
  async uploadNewsHeaderImage(file, newsId) {
    try {
      if (!file) {
        return { success: false, error: 'No file provided' };
      }

      const fileExt = file.name.split('.').pop();
      const fileName = `${newsId}-${Date.now()}.${fileExt}`;
      const filePath = `news-headers/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('news')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        });

      if (uploadError) {
        throw uploadError;
      }

      const { data } = supabase.storage
        .from('news')
        .getPublicUrl(filePath);

      return { 
        success: true, 
        url: data.publicUrl,
        path: filePath
      };
    } catch (error) {
      console.error('Error uploading header image:', error);
      return { success: false, error: error.message };
    }
  },

  async deleteNewsHeaderImage(path) {
    try {
      if (!path) {
        return { success: false, error: 'No path provided' };
      }

      const { error } = await supabase.storage
        .from('news')
        .remove([path]);

      if (error) {
        throw error;
      }

      return { success: true };
    } catch (error) {
      console.error('Error deleting header image:', error);
      return { success: false, error: error.message };
    }
  }
};
